import { ChangeDetectorRef, Component, HostListener, Input, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { MatDialog } from '@angular/material/dialog';

interface Video {
  platform: 'youtube' | 'vimeo';
  principal: boolean;
  title: string;
  type: 'promocional' | 'review';
  thumbnailUrl?: string;
  url: { changingThisBreaksApplicationSecurity: string };
};

@Component({
  selector: 'app-carrossel-imagens',
  templateUrl: './carrossel-imagens.component.html',
  styleUrls: ['./carrossel-imagens.component.css'],
})
export class CarrosselImagensComponent implements OnInit {
  @Input() imagens: Array<any>;
  @Input() alt: string;
  @Input() produtoVideo: any;
  @Input() produtoNome: string;
  @Input() produtoMarca: string;
  @Input() videos!: Array<Video>

  imagensFinal: Array<any> = [];
  dividerLayout: 'horizontal' | 'vertical' = 'vertical';
  imagemAtualUrl: Array<any> | null = null;
  indiceSelecionado: number | null = 0;
  imagemAtualScale: number = 1.0; // Controla o nível de zoom

  transformOrigin = '50% 50%'; // Para o pan no desktop
  public isMobileView: boolean = false; // Detecta se é mobile

  customOptions: OwlOptions = {
    loop: true,
    margin: 20,
    autoplay: false,
    autoplayTimeout: 3500,
    dots: true,
    center: false,
    stagePadding: 20,
    navSpeed: 700,
    navText: ['', ''],
    nav: true,
    mouseDrag: true,
    responsive: {
      0: { items: 1 },
      576: { items: 1 },
      768: { items: 3 },
      992: { items: 3 },
      1200: { items: 5 },
      1400: { items: 5 }
    }
  };
  galeriaResponsiveOptions: any[] = [
    {
      breakpoint: '1500px',
      numVisible: 5
    },
    {
      breakpoint: '1024px',
      numVisible: 3
    },
    {
      breakpoint: '768px',
      numVisible: 2
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  visible: boolean = false;
  displayImages: boolean = false;
  activeTab: 'videos' | 'imagens' = 'imagens';
  height: number;
  promotionalVideos: Array<Video>;
  reviewVideos: Array<Video>;

  constructor(private dialog: MatDialog, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    if (this.videos?.[0]?.url) {
      this.produtoVideo = this.videos[0].url;
      const videosWithThumbnail = [...this.videos.map(e => {
        e.thumbnailUrl = this.getYoutubeThumbnail(e.url)
        return e;
      })];
      this.videos = videosWithThumbnail

      this.promotionalVideos = videosWithThumbnail.filter(v => v.type === 'promocional');
      this.reviewVideos = videosWithThumbnail.filter(v => v.type === 'review');
      this.height = window.screen.height;
    }
    this.ajustarImagens();
    this.setDividerLayout();
    this.checkDeviceWidth(); // Verifica o tamanho da tela ao iniciar
  }

  @HostListener('window:resize')
  onResize() {
    this.setDividerLayout();
    this.checkDeviceWidth(); // Verifica a cada redimensionamento da janela
    this.cdr.markForCheck();
  }

  private checkDeviceWidth(): void {
    this.isMobileView = window.innerWidth <= 768; // Define o breakpoint para mobile
    // Reseta o zoom se a visualização mudar para garantir o comportamento correto
    this.imagemAtualScale = 1.0;
    this.transformOrigin = '50% 50%';
  }

  onClickImagesTab() {
    this.activeTab = 'imagens';
    this.displayImages = true;
    this.imagemAtualScale = 1.0; // Reseta o zoom ao trocar de aba
    this.transformOrigin = '50% 50%';
  }
  handleVideoClick(url: any) {
    this.produtoVideo = url;
  }

  handleImageClick(index: any, url: string) {
    this.imagemAtualUrl = [{ url: url }];
    this.indiceSelecionado = index;
    this.imagemAtualScale = 1.0; // Reseta o zoom ao trocar de imagem
    this.transformOrigin = '50% 50%';
  }

  @HostListener('window:resize')
  getWindowWidthSize() {
    this.height = window.screen.height;
    this.cdr.markForCheck();
  }

  setResize(percent: number): number {
    return this.height * (percent / 100)
  }

  getYoutubeThumbnail(url: { changingThisBreaksApplicationSecurity: string }): string | null {
    const match = url.changingThisBreaksApplicationSecurity.match(/(?:embed\/|v=)([a-zA-Z0-9_-]{11})/);
    return match ? `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg` : null;
  }

  scaleUp() {

    console.log('tentei')
    if (this.imagemAtualScale >= 6.0) return; // Limite máximo de zoom
    this.imagemAtualScale = Math.round((this.imagemAtualScale + 0.5) * 10) / 10;
  }

  scaleDown() {
    if (this.imagemAtualScale <= 1.0) return; // Limite mínimo de zoom
    this.imagemAtualScale = Math.round((this.imagemAtualScale - 0.5) * 10) / 10;
    if (this.imagemAtualScale <= 1.0) { // Se voltar ao normal, centraliza
      this.transformOrigin = '50% 50%';
    }
  }

  private ajustarImagens() {
    if (!this.imagens || this.imagens.length === 0) {
      this.imagensFinal = [];
      return;
    }
    this.imagensFinal = [...this.imagens];
    while (this.imagensFinal.length < 5) {
      this.imagensFinal.push(this.imagens[this.imagensFinal.length % this.imagens.length]);
    }
    this.imagemAtualUrl = [{ url: this.imagensFinal?.[0]?.url }];
    this.imagemAtualScale = 1.0; // Garante reset inicial
    this.transformOrigin = '50% 50%';
  }

  openZoom(url?: string, index?: number) {


    if (url && index !== undefined) {
      this.handleImageClick(index, url)
    }
    this.visible = true;
    this.displayImages = true;
    this.activeTab = "imagens"
    this.imagemAtualScale = 1.0; // Garante reset ao abrir o diálogo
    this.transformOrigin = '50% 50%';
  }

  private setDividerLayout() {
    const w = window.innerWidth;
    this.dividerLayout = w < 768 ? 'horizontal' : 'vertical';
  }

  onZoomToggle(): void {
    if (this.imagemAtualScale > 1) { // Se já está com zoom, reseta
      this.imagemAtualScale = 1.0;
      this.transformOrigin = '50% 50%';
    } else { // Se não está com zoom, aplica um zoom padrão
      this.imagemAtualScale = 2.0; // Zoom inicial ao clicar
    }
  }

  onZoomMove(ev: MouseEvent): void {
    // ATENÇÃO: Pan do mouse APENAS SE NÃO FOR MOBILE E SE TIVER ZOOM
    if (this.isMobileView || this.imagemAtualScale <= 1) {
      this.transformOrigin = '50% 50%'; // No mobile, a origem sempre fica no centro para o scroll
      return;
    }

    const el = ev.currentTarget as HTMLElement;
    const rect = el.getBoundingClientRect();

    const x = ((ev.clientX - rect.left) / rect.width) * 100;
    const y = ((ev.clientY - rect.top) / rect.height) * 100;

    const clamp = (v: number) => Math.max(0, Math.min(100, v));
    this.transformOrigin = `${clamp(x)}% ${clamp(y)}%`;
  }
}
